<template>
    <transition name="slide-in">
      <ModalControl :is_visible="is_visible">
        <div class="flex flex-row items-center justify-between">
          <LabelControl :content="$t('mip012')" />
          <IconControl @click="closeModal" id="exit-black" :width="50" :height="50" />
        </div>
        <KeypadControl ref="KeypadControl" input_type="TIN" :limit="9"
          @digits-full="handleTIN" @digits-changed="updateDigits"
          @digits-cleared="updateDigits" />
  
        <div class="flex w-full justify-center align-center text-center">
          <div class="flex flex-col justify-center align-center text-center tin-btn" style="width: 38rem;">
            <ButtonControl @click="submitTIN" :disabled="!inputted_tin"
              :button_loading="loading" class='w-full' :text="$t('btn008')" />
          </div>
        </div>
      </ModalControl>
    </transition>

    <!-- Update successful -->
    <transition name="slide-in">
        <ModalControl :is_visible="this.toggle_message">
            <div class="flex flex-col justify-center align-center items-center p-8">
                <img :src="getIcon('check')" class="mb-10">
                <LabelControl type="heading" class="text-grey-darkest font-bold text-5xl mb-8 text-center"
                    :content="$t('mip016')" />
                <div class="flex w-full text-center justify-center align-center items-center">
                    <ButtonControl :text="$t('btn014')" theme="success" @click="toggleMessage" />
                </div>
            </div>
        </ModalControl>
    </transition>

    <!-- Existing Session -->
    <transition name="slide-in">
        <ModalControl :is_visible="this.existing_session">
            <SessionTimeoutControl />
        </ModalControl>
    </transition>

    <!-- Privacy Policy -->
    <transition name="slide-in">
        <ModalControl :is_visible="this.toggle_privacy" is_scrollable is_table :overlay_enabled="false">
            <div class="flex flex-col justify-center pt-10 px-10">
              <LabelControl type="dynamic" class="text-grey-darkest font-bold text-6xl mb-8 uppercase text-center"
              content="Privacy Policy" />
                            
              <PrivacyPolicyControl/>

                <div class="flex flex-row justify-center align-center items-center w-full" style="gap: 3rem;">
                  <ButtonControl text="I Disagree" theme="error" @click="toggle_privacy = false" class="w-full"/>
                  <ButtonControl text="I Agree" class="px-8 mr-5 w-full" theme="success" @click="submitTIN" />
                </div>
            </div>
        </ModalControl>
    </transition>

  </template>
  
<script>
  import ModalControl from '@/components/controls/ModalControl.vue';
  import LabelControl from '@/components/controls/LabelControl.vue';
  import IconControl from '@/components/controls/IconControl.vue';
  import KeypadControl from '@/components/controls/KeypadControl.vue';
  import ButtonControl from '@/components/controls/ButtonControl.vue';
  import SessionTimeoutControl from './SessionTimeoutControl.vue';
  import PrivacyPolicyControl from '@/components/controls/PrivacyPolicyControl.vue';
  import mixin from '@/mixins/controls.js';
  import user from '@/services/user';
  
  export default {
    name: 'TINModal',
    inject: ['setLoading', 'setError'],
    emits: ['close'],
    mixins: [mixin],
    components: {
      ModalControl,
      LabelControl,
      IconControl,
      KeypadControl,
      ButtonControl,
      SessionTimeoutControl,
      PrivacyPolicyControl,
    },
    props: {
      is_visible: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        inputted_tin: false,
        tin_value: '',
        loading: false,
        toggle_message: false,
        existing_session: false,
        toggle_privacy: false,
        hash: "",
        uuid: "",
      };
    },
    mounted() {
        const state = this.$store.state.user;
        this.full_name = `${state.first_name} ${state.middle_name} ${state.last_name}`;
        this.phone_number = state.mobile;
        this.hash = state.hash;
        this.tin = state.tin;
        this.qr = state.qr;
        this.uuid = state.uuid;
        this.email = state.email;
        this.key = state.key;

        const enrollee = this.$store.state.pin_enrollment;
        this.enrollee_mobile = enrollee.mobile; 
        this.enrollee_email = enrollee.email;
        this.enrollee_name = enrollee.name;
        this.enrollee_uuid = enrollee.uuid;
        this.enrollee_hash = enrollee.hash;
    },
    methods: {
      handleTIN(value) {
        this.inputted_tin = true;
        let tinString = value.join('');
        let formatted_tin = tinString.replace(/(\d{3})(?=\d)/g, '$1-');
        this.tin_value = formatted_tin;
      },
      updateDigits() {
        this.inputted_tin = false;
      },
      submitTIN() {
        this.setLoading(true);
        // this.loading = true;
        user.editTIN(this.hash, this.tin_value, this.key)
          .then(() => {
            // this.loading = false;
            this.setLoading(false);
            this.$store.commit('updateTIN', this.tin_value);
            this.showSuccess('TIN updated successfully!');
            this.closeModal();
            this.toggleMessage();
          })
          .catch((error) => {
            if (error.response && error.response.status === 403) {
                // this.loading = false;
                this.setLoading(false);
                this.closeModal();
                this.resetUserData();
                this.clearUserCookie();
                this.toggleExistingSessionModal();
            }
            // this.loading = false;
            this.setLoading(false);
            this.closeModal();
            console.error("Error while editing TIN:", error.response?.data?.message || error);
          });
      },
      closeModal() {
        this.$emit('close');
      },
      toggleMessage() {
            this.toggle_message = !this.toggle_message;
      },
      openPrivacy() {
        this.toggle_privacy = true;
        this.emit('closeModal');
      }
    },
  };
</script>
  
<style scoped>

@media (min-width: 2500px) {
  .tin-btn {width: 60rem !important; margin-top: -6rem !important;}
    
}
  </style>